import {
  ECOVENTURE_CATEGORIES
} from '../helpers/constants'

export const getTripLength = (programme) => {
  if (programme.category === ECOVENTURE_CATEGORIES.ECOVENTURE) {
    const lengthMax = programme.length_max
    const lengthMin = programme.length_min
  
    if (lengthMax === lengthMin && (lengthMin !== null)) {
      return `${lengthMin} weeks`
    }
    else if (lengthMin < lengthMax) {
      return `${lengthMin} - ${lengthMax} weeks`
    }
    else if (Number.isInteger(lengthMin) && lengthMax === null) {
      return `${lengthMin}+ weeks`
    }
  }
  else if (programme.category === ECOVENTURE_CATEGORIES.EXPEDITION) {
    const length = programme.expedition_length
  
    return `${length} days`
  }
  
  return ''
}
